import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import '../styles/theme-alt.css'
import '@glideapps/glide-data-grid/dist/index.css'
import * as Sentry from "@sentry/react";

// Initialize PostHog
import '../instrumentation-client'

// Import the generated route tree
import { routeTree } from './routeTree.gen'

// Create a new router instance
const router = createRouter({ routeTree })

// Register the router instance for type safety
declare module '@tanstack/react-router' {
    interface Register {
        router: typeof router
    }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
    <Sentry.ErrorBoundary fallback={<div>Something went wrong</div>}>
        <React.StrictMode>
            <RouterProvider router={router} />
        </React.StrictMode>
    </Sentry.ErrorBoundary>,
)
